module.exports = __webpack_public_path__ + "static/business-header-big.fc1157be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business-header-big.jpg
// module id = 156
// module chunks = 168707334958949